import React from "react";

const CTAButton = ({ node }) => {
  const {
    text,
    textColor,
    backgroundColor,
    textSize,
    url,
    ctaAlign,
    ctaWidth,
  } = node;
  return (
    <div style={{ textAlign: ctaAlign }}>
      {text ? (
        <a href={url}>
          <button
            style={{
              color: textColor,
              fontSize: textSize || "18px",
              background: backgroundColor,
              padding: "12px 30px 11px",
              border: "none",
              borderRadius: "3px",
              cursor: "pointer",
              fontWeight: 700,
              width: ctaWidth + "%" || "100%",
              boxShadow: "3px 3px #000",
            }}
          >
            {text}
          </button>
        </a>
      ) : (
        ""
      )}
    </div>
  );
};

export default CTAButton;
